import React, { useEffect, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { useLocation, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import PageHeader from "../PageHeader";

export default function FireEquipmentStatusDetailComponent() {
  const { id, equipmentId } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    apiWrapper(async () => {
      const result = await fireonApi.getFireFightingFacilityById(equipmentId);

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  return (
    <section id="darkMode" class="mbSection darkMode pb-per">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container overContainer">
        <p class="tableTitle mb-24">소방설비정보</p>
      </div>
      {dataSource && (
        <div class="container pb-100">
          <div >
            <div class="dashedBox">
              <div class="dashed-item">
                <p class="dashed-title">소방설비분류</p>
                <p class="dashed-txt">{dataSource.category}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">소방설비명칭</p>
                <p class="dashed-txt">{dataSource.name}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">형식승인번호</p>
                <p class="dashed-txt">{dataSource.approvalNumber}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설비모델명</p>
                <p class="dashed-txt">{dataSource.modelName}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설비일련번호</p>
                <p class="dashed-txt">{dataSource.serialNumber}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설비제원</p>
                <p class="dashed-txt">{dataSource.specifications}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">제조사</p>
                <p class="dashed-txt">{dataSource.manufacturer}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">제조년월</p>
                <p class="dashed-txt">{dataSource.manufactureDate}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">구입처</p>
                <p class="dashed-txt">{dataSource.purchaseCompany}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">구입처 연락처</p>
                <p class="dashed-txt">{dataSource.purchaseContact}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">구입일자</p>
                <p class="dashed-txt">{dataSource.purchaseDate}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">구입가격</p>
                <p class="dashed-txt">{dataSource.purchasePrice}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">AS 연락처</p>
                <p class="dashed-txt">{dataSource.asContact}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설치일자</p>
                <p class="dashed-txt">{dataSource.installationDate}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설치업체</p>
                <p class="dashed-txt">{dataSource.installationCompany}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설치업체 연락처</p>
                <p class="dashed-txt">{dataSource.installationContact}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설치 층</p>
                <p class="dashed-txt">{dataSource.installationFloor}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">설비사진</p>
                <p class="dashed-txt">{dataSource.photoImage === '' ? '무' : '유'}</p>
              </div>
              <div class="dashed-item">
                <p class="dashed-title">운영상태</p>
                <p class="dashed-txt">{dataSource.operationalStatus}</p>
              </div>
            </div>
          </div>
          <div class="building-item-wrap">
          </div>
        </div>
      )}
      <div id="dashboardMenu" class="active_05">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
